import { Button, Grid, Link, Paper } from "@mui/material";
import { Login } from "../Login/Login";
import Tabs from "../Tabs/Tabs";
import theme, { white, button } from "../../theme";

import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { proceed, stopLoading } from "../../redux/QuestionnaireSlice";
import { reset } from "../Registration/RegistrationSlice";
import { selectAccount } from "../../redux/UserSlice";




export default function MainPage() {
    const [login, setLogin] = useState(false)
    const history = useHistory();
    const dispatch = useAppDispatch()
    const account = useAppSelector(selectAccount)
    useEffect(() => {
        localStorage.clear();
        dispatch(reset())
        dispatch(proceed(false))
        dispatch(stopLoading())
    }, [])

    return (
        <>
            <Grid container sx={{
                [theme.breakpoints.up("xl")]: {
                    marginTop: '13em', marginBottom: '10em'
                }, [theme.breakpoints.up("xs")]: {
                    marginTop: '8em', marginBottom: '10em'
                }
            }} justifyContent="space-around" >
                {!account ?

                    <Grid item xs={login ? 8 : 12} md={3}>
                        {login ? <Login setLogin={setLogin} /> : <Grid container justifyContent='space-evenly'>
                            <Grid item xs={5} md={10}>
                                <Button sx={{
                                    width: "100%",
                                    [theme.breakpoints.up("xs")]: {
                                        height: "7em", fontSize: 14, marginTop: '0.5em'
                                    },
                                    [theme.breakpoints.up("sm")]: {
                                        height: "7em", fontSize: 16, marginTop: '0.5em'
                                    },
                                    [theme.breakpoints.up("lg")]: {
                                        height: "10em", fontSize: 20, marginTop: '0.5em'
                                    },
                                    [theme.breakpoints.up("xl")]: {
                                        height: "10em", fontSize: 22,
                                    },
                                    textTransform: "none", textAlign: "center", '&.MuiButton-root:hover': { boxShadow: 9 }
                                }} component={Paper} onClick={() => { history.push("/form") }}><b>Ready to apply for the program</b></Button>


                            </Grid>
                            <Grid item xs={5} md={10}>
                                <Button sx={{
                                    width: "100%",
                                    [theme.breakpoints.up("xs")]: {
                                        height: "7em", fontSize: 14, marginTop: '0.5em'
                                    },
                                    [theme.breakpoints.up("sm")]: {
                                        height: "7em", fontSize: 16, marginTop: '0.5em'
                                    },
                                    [theme.breakpoints.up("lg")]: {
                                        height: "10em", fontSize: 20, marginTop: '0.5em'
                                    },
                                    [theme.breakpoints.up("xl")]: {
                                        height: "10em", fontSize: 22,
                                    },
                                    textTransform: "none", textAlign: "center", '&.MuiButton-root:hover': { boxShadow: 9 }
                                }} component={Paper}
                                    onClick={() => { setLogin(true) }}><b>Already applied for the program and received a Registration Number</b></Button>
                            </Grid>
                        </Grid>}
                    </Grid> : ''}

                <Grid item xs={12} md={8}   >
                    <Tabs />
                </Grid>
            </Grid>
        </>
    )

}